// extracted by mini-css-extract-plugin
export default {"popoverContainer":"popoverContainer--DcXGg","closeButtonContainer":"closeButtonContainer--Sfj79","closeButton":"closeButton--Oj03_","animation-bzdot9":"animation-bzdot9--pW3uY"};